import { uiSagasFactory } from '../../../restux/ui/restuxUiSagas.factory'
import { medicalEventFilesConfig } from './medicalEventFiles.model'

const paginationSagas = uiSagasFactory(medicalEventFilesConfig)

export const medicalEventsFilesSagas = {
  ...paginationSagas,
}
